<template>
  <div class="home main_page">
    <header-app
      @showLogin="opt($event)"
      @changeLanguage="changeLanguage($event)"
      @goRouter="goRouter($event)"
      @toLives="pageLiveCourse"
      @goHome="goHome"
      @quite="quite"
      @redirectFooter="redirectFooter($event)"
      @languageShow="languageShow"
      @languageHidden="languageHidden"
      :formLabel="formLabel"
      :userId="userId"
      :userImg="userImg"
      :languageType="languageType"
      :message_number="message_number"
      ref="header"
    />
    <div class="home_middle" ref="home_middle" style="">
      <div class="dubble60 in_sp" v-show="userId != ''"></div>
      <router-view
        @info="info"
        :userId="this.userId"
        v-on:edit-head-image="edit_head_image"
      ></router-view>
    </div>
    <footer-app @redirectFooter="redirectFooter($event)" />
    <!-- dialog -->
    <el-dialog
      class="home_dialog_page"
      :visible.sync="login_show"
      width="30%"
      :modal="true"
      :show-close="false"
      :close-on-click-modal="isShowModal"
      :before-close="test"
    >
      <div class="dialog_page_header"></div>
      <div class="dialog_page_main dialog-custom">
        <div class="dialog_page_item">
          <div class="img_exit_login" @click="hide_login">
            <img src="/static/images/wrong-while_hover.png" />
          </div>
          <ul>
            <li class="cursor" @click="opt('regist')" v-if="safeMode == 1">
              <img src="/static/images/renlianshibie.png" />
              <span
                :class="{ dialog_page_item_active: dialog_item == 'regist' }"
                >{{ $t("home.faceIn") }}</span
              >
            </li>
            <li class="cursor li-dn" @click="opt('login')" v-if="safeMode == 0">
              <img src="/static/images/dengluzhuce.png" />
              <span
                :class="{ dialog_page_item_active: dialog_item == 'login' }"
                >{{ $t("home.accountIn") }}</span
              >
            </li>
          </ul>
        </div>
        <el-form
          class="optForm distance_top_30"
          label-position="labelPosition"
          label-width="80px"
          :model="formLabel"
        >
          <el-form-item v-if="dialog_item == 'login'" class="us-mail">
            <el-input
              class="user_input"
              v-model="formLabel.email"
              :placeholder="$t('home.accountOrEmail')"
              @keyup.enter.native="login()"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="dialog_item == 'login'" class="us-pw">
            <el-input
              class="pass_input"
              type="password"
              v-model="formLabel.password"
              :placeholder="$t('home.passwordDigits')"
              minlength="8"
              maxlength="16"
              @keyup.enter.native="login()"
              @keyup.delete.native="checkss()"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="dialog_item == 'login'" class="div-remember">
            <el-checkbox-group v-model="formLabel.remember">
              <!-- <template v-if="checkDataGeneralEnvironment==4">
                <el-checkbox
                  :label="$t('home.keepLogin')"
                  name="remember"
                ></el-checkbox>
              </template>
              <template v-else> -->
                <el-checkbox
                  :label="$t('home.rememberMe')"
                  name="remember"
                ></el-checkbox>
              <!-- </template> -->
            </el-checkbox-group>
          </el-form-item>
          <el-row>
            <div v-if="dialog_item == 'regist'" class="vodeo_box">
              <video
                ref="video"
                id="video"
                width="290"
                height="200"
                autoplay
              ></video>
              <canvas
                style="display: none"
                id="canvasCamera"
                :width="290"
                :height="200"
              ></canvas>
              <img :src="imgSrc" alt class="tx_img" />
            </div>
            <el-button
              round
              class="form_btn"
              v-if="dialog_item == 'regist'"
              @click="crooper()"
              >{{ $t("home.identifyStart") }}</el-button
            >
            <el-button
              round
              class="form_btn login_button1 btn-login"
              v-else
              @click="login()"
              >{{ $t("home.immediateLogin") }}</el-button
            >
          </el-row>
          <el-row
            v-if="dialog_item == 'login'"
            class="login_button"
            style="text-align: center"
          >
            <span
              class="forget"
              style="cursor: pointer"
              @click="
                goRouter('/home/email');
                login_show = false;
              "
              >{{ $t("home.forgetPass") }}</span
            >
          </el-row>
        </el-form>
      </div>
    </el-dialog>

    <!-- Danh sách công ty -->
    <el-dialog :visible.sync="dialogVisibleCompanyList" width="30%" class="conpany_login" :class="[{mobile: mobile}, {pc: !mobile}]">
        <div class="blog-pop">
            <div class="blog-pop-box">
                <h4>{{ $t("home.welcome") }}</h4>
                <p class="title-p">{{ $t("home.selectCompanyTitle") }}</p>
                <div class="blog-content">
                  <div v-for="(item, index) in userList" :key="index" class="fea" :class="{active: item.active}" @click="selectCompany(item.token, item.series, index, indexPrev)">
                      <img src="/static/images/office-100.png">
                      <p>{{item.companyName}}</p>
                  </div>
                </div>
                <a class="banner-btn" :class="{disabled: companyLoginInfo.token == null}" @click="loginCompany(companyLoginInfo.token, companyLoginInfo.series)">{{ $t("js.hint") }}</a>
            </div>
        </div>
    </el-dialog>


  </div>
</template>

<script>
import Vue from "vue";
import { lang } from "../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;

import eventBus from "../assets/eventBus/eventBus.js";
import en from "element-ui/lib/locale/lang/en";
import ja from "element-ui/lib/locale/lang/ja";
import vi from "element-ui/lib/locale/lang/vi";
import zh from "element-ui/lib/locale/lang/zh-CN";
import picker from "../../node_modules/element-ui/lib/locale/index";
import md5 from "js-md5";
import Header from "../views/header/header.vue";
import Footer from "../views/footer/footer.vue";
import {mapActions, mapState} from "vuex";

export default {
  name: "home",
  components: {
    "header-app": Header,
    "footer-app": Footer
  },
  data() {
    return {
      isShowModal: false,
      app_Android_flag: false,
      imgSrc: "",
      mediaStreamTrack: null,
      stream: null,
      learn_analysis_flag: false,
      login_show: false, //是否显示登录注册内容
      dialog_item: "login", //默认登录
      userId: "",
      userImg: "static/images/profile.jpg", //默认头像
      formLabel: {
        userName: "",
        email: "",
        password: "",
        repeatPassword: "",
        agree: "",
        remember: ""
      },
      show_item: false, //课程与学院下拉列表显示
      emailCheck: false,
      header_background: false,
      languageType: false,
      gridData: [],
      liveLessonMessage: false,
      safeMode: 0, //是否为安全模式 1是；0不是；
      faceFlag: 0, //登录模式 1 安全模式 ；0 一般模式 ；
      messageNumber: 0, //个人信息的数量
      status: "",
      resultFlag: false, //结果标志
      message_number: 0,
      message_number_person: 0,
      keyword: null,
      isChecked: true,
      isCheckedStatus: false,
      activeID: null,
      isCheckIphone: false,
      checkDataGeneralEnvironment: 0,
      userList: [],
      companyId: null,
      dialogVisibleCompanyList: false,
      companyLoginInfo: {
        token: null,
        series: null
      },
      indexPrev: null
    };
  },
  computed: {
    // Lấy dữ liệu từ store
    ...mapState({
        mobile: (state) => state.header.mobile
    }),
  },
  watch: {
    login_show: function(val) {
      if (val) {
        this.clearFormLabel();
      }
      if (this.login_show) {
        this.login_enterprise = false;
      }
    },
    login_enterprise: function() {
      if (this.login_enterprise) {
        this.login_show = false;
      }
    },
    liveLessonMessage: function (value) {
      if (!value) {
        this.$refs.header.closeLive()
      }
    },
    dialogVisibleCompanyList: function (value) {
      this.companyLoginInfo = {
        token: null,
        series: null
      }
      this.indexPrev = null;
    },
  },
  methods: {
    // get methods from vuex
    ...mapActions("schoolBussiness", ["resetDataCourse"]),

    checkss() {
      if (!this.formLabel.password) {
        // this.formLabel.email = "";
      }
    },

    test() {},

    // hide dialog login
    hide_login: function() {
      this.login_show = false;
    },

    // go to policy
    policy: function() {
      const that = this;
      if (1 == that.$lang()) {
        this.$router.push("/home/policy_zh");
      } else if (2 == that.$lang()) {
        this.$router.push("/home/policy_en");
      } else if (3 == that.$lang()) {
        this.$router.push("/home/policy_ja");
      } else if (4 == that.$lang()) {
        this.$router.push("/home/policy_vi");
      } else {
        this.$router.push("/home/policy_ja");
      }
    },

    // go to faq
    faq: function() {
      this.$router.push("/home/faq_new");
    },

    //  go to manual
    operation: function() {
      this.$router.push("/home/manual");
    },

    // go to protocol
    protocol: function() {
      const that = this;
      if (1 == that.$lang()) {
        this.$router.push("/home/protocol_zh");
      } else if (2 == that.$lang()) {
        this.$router.push("/home/protocol_en");
      } else if (3 == that.$lang()) {
        this.$router.push("/home/protocol_ja");
      } else if (4 == that.$lang()) {
        this.$router.push("/home/protocol_vi");
      } else {
        this.$router.push("/home/protocol_ja");
      }
    },

    // set width of dialog
    setDialogWidth: function() {
      let val = document.body.clientWidth;
      let dialogWidth = 0;
      const def = 1024;
      if (val < 1024) {
        dialogWidth = "300px";
      } else {
        dialogWidth = "300px";
      }

      return dialogWidth;
    },

    // set style for class "el-input__inner"
    selfStyle() {
      document.getElementsByClassName("el-input__inner")[0].style.borderColor = "#6d6d6d";
    },

    getName: function(val) {
      return jumpTo[val];
    },

    idHidden() {
      this.learn_analysis_flag = true;
    },

    opt: function(str) {
      const that = this;
      that.login_show = true;
      that.dialog_item = 'login';
      //清空相关输入框
      if (document.cookie.length > 0) {
        // 通过分号(;)作为分割符cookie字符串
        var arr = window.document.cookie.split(";");
        // 循环遍历分隔后字符串数组
        for (var i = 0; i < arr.length; i++) {
          // 再将字符串通过等号(=)进行分割
          var arr2 = arr[i].split("=");
          // 判断查找相对应的值,replace(/\s*/g, "")表示去掉字符串中的空格
          if (arr2[0].replace(/^\s+|\s+$/g, "") === "remember") {
            that.formLabel.remember = arr2[1];
          } else if (arr2[0].replace(/^\s+|\s+$/g, "") === "email") {
            that.formLabel.email = arr2[1];
          } else if (arr2[0].replace(/^\s+|\s+$/g, "") === "password") {
            // Giải mã pass khi lưu đăng nhập
            const decrypt = (salt, encoded) => {
              const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
              const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
              return encoded
                  .match(/.{1,2}/g)
                  .map((hex) => parseInt(hex, 16))
                  .map(applySaltToChar)
                  .map((charCode) => String.fromCharCode(charCode))
                  .join("");
            };
            const decrypted_string = decrypt("salt", arr2[1]);
            that.formLabel.password = decrypted_string;
          }
        }
        that.$refs.formLabel = that.formLabel;
      }
      if (str === "regist") {
        that.setTimeout(() => {
          if (this.safeMode === 1) {
            that.openCamera();
          }
        }, 100);
      } else {
        // that.stream.getTracks().forEach(track => track.stop());
        // let video = document.getElementById("video");
        // console.log(video);
        // video.src = "";
      }
      that.$nextTick(function() {
        if (this.safeMode === 1) {
          that.openCamera();
        }
      });
    },

    // go to page home
    goHome: function() {
      this.$router.push("/");
    },

    info: function(message) {
      if (message == "regist") {
        this.login_show = true;
        this.dialog_item = message;
      }
    },

    showItem: function() {
      const that = this;
      that.show_item = !that.show_item;
    },

    outItem: function() {
      const that = this;
      that.show_item = false;
    },

    showItemUserName: function() {
      this.show_item_userName = !this.show_item_userName;
    },

    outItemUserName: function() {
      this.show_item_userName = false;
    },

    showAppDownload: function() {
      const that = this;
      that.show_appDownload = !that.show_appDownload;
    },

    outAppDownload: function() {
      const that = this;
      that.show_appDownload = false;
    },

    community: function() {
      this.$router.push("/home/community");
    },

    goSearch: function(url) {
      let href = this.$router.resolve({
        path: url
      });
      window.open(href.href, "_blank");
    },

    // redirect page
    goRouter: function(url) {
      let envCode = this.checkGeneralEnvironment();

      if(url == this.$CONST.HEADER.ROUTER.SCHOOLBUSINESS){
        url = this.$CONST.HEADER.ROUTER.SCHOOLBUSINESS_VN;
        if (envCode != 4 && envCode != 0) {
          //判断该登陆者是有学习计划
          this.$api
          .post("/coursesPurchase/getScheduleStudent", {
            userId: this.userId
          })
          .then((response) => {
            if (response.data !=  0) {
              url = this.$CONST.HEADER.ROUTER.SCHOOLBUSINESS_SCHEDULE;
            } 
          });
        }
      }

      this.$router.push(url);
    },

    // scroll to Top
    handleScroll() {
      //改变元素的top值
      let scrollTop = document.getElementById("app").scrollTop;
      if (scrollTop == 0) {
        //document.querySelector('.home-div').style.backgroundColor = "#323232"
        this.header_background = false;
      } else {
        // document.querySelector('.home-div').style.backgroundColor = "unset"
        this.header_background = true;
      }
    },

    // register user
    register: function() {
      //用户名不可以为空
      if (this.formLabel.userName == null || this.formLabel.userName == "") {
        this.$el_alert_type(window.vm.$i18n.t("js.userNameNull"), "warning");
        return;
      }

      //邮箱不可以为空
      if (this.formLabel.email == null || this.formLabel.email == "") {
        this.$el_alert_type(window.vm.$i18n.t("js.email"), "warning");
        return;
      }

      //验证邮箱格式
      let reg = new RegExp(
        /^[a-z\d]+(\.[a-z\d]+)*@([\da-z](-[\da-z])?)+(\.{1,2}[a-z]+)+$/
      );
      if (!reg.test(this.formLabel.email)) {
        this.$el_alert_type(window.vm.$i18n.t("js.formatWrong"), "warning");
        return;
      }

      //密码不可以为空
      if (this.formLabel.password == null || this.formLabel.password == "") {
        this.$el_alert_type(window.vm.$i18n.t("js.password"), "warning");
        return;
      }

      //验证密码
      let passReg = new RegExp(/^(?![0-9]+$)(?![a-zA-Z]+$)[A-Za-z0-9]{8,16}$/);
      if (!passReg.test(this.formLabel.password)) {
        this.$el_alert_type(window.vm.$i18n.t("js.passwordFormat"), "warning");
        return;
      }
      passReg = new RegExp(/^[a-zA-Z0-9_+-=*#%$]+$/);
      if (!passReg.test(this.newPassword)) {
        this.$el_alert_type(window.vm.$i18n.t("js.passwordFormat"), "warning");
        return;
      }

      //重复密码不可以为空
      if (
        this.formLabel.repeatPassword == null ||
        this.formLabel.repeatPassword == ""
      ) {
        this.$el_alert_type(window.vm.$i18n.t("js.repeatPassword"), "warning");
        return;
      }

      //验证两次密码是否一致
      if (this.formLabel.password != this.formLabel.repeatPassword) {
        this.$el_alert_type(window.vm.$i18n.t("js.different"), "warning");
        return;
      }

      //判断是否同意协议
      if (!this.formLabel.agree) {
        this.$el_alert_type(window.vm.$i18n.t("js.service"), "warning");
        return;
      }

      //验证邮箱/用户名是否重复
      this.$api
        .post("/register/checkIsRegistState", {
          email: this.formLabel.email,
          name: this.formLabel.userName
        })
        .then(response => {
          if (response.data.flag == 1) {
            this.$el_alert_type(response.data.message, "warning");
          } else {
            this.saveRegisteredUserInfo();
          }
        });
    },

    // save registered user info 
    saveRegisteredUserInfo: function() {
      this.$api
        .post("/register/saveRegisteredUserInfo", {
          password: this.formLabel.password,
          name: this.formLabel.userName,
          email: this.formLabel.email
        })
        .then(() => {
          //发送注册邮件
          this.$api
            .post("/register/sendCheckEmail", {
              activatePurpose: 0,
              email: this.formLabel.email,
              domainName: window.location.host
            })
            .then(() => {
              this.login_show = false;
              this.$router.push({
                path: "/home/register_email",
                query: {
                  activatePurpose: "0",
                  email: this.formLabel.email
                }
              });
              this.clearFormLabel();
            });
        });
    },

    // handle login
    login: function() {
      if (!this.formLabel.email) {
        this.$el_alert_type(window.vm.$i18n.t("js.account"), "warning");
        return;
      }

      if (!this.formLabel.password) {
        this.$el_alert_type(window.vm.$i18n.t("js.passwordNull"), "warning");
        return;
      }
      this.$api
        .post("/login/login", {
          password: md5(this.formLabel.password),
          loginName: this.formLabel.email
        })
        .then(response => {
          this.resetDataCourse();
          window.sessionStorage.removeItem("arrCourse");
          window.sessionStorage.setItem("course_login_flg", 1);
          if (response.data.codeFlag == "1001") {
            window.sessionStorage.setItem("check_login", 0);
            if (this.formLabel.remember == "1") {
              window.sessionStorage.setItem(
                "register_password_change",
                response.data.passwordChangeFlag
              );
              /// Mã hoá pass
              const crypt = (salt, text) => {
                const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
                const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
                const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);

                return text
                    .split("")
                    .map(textToChars)
                    .map(applySaltToChar)
                    .map(byteHex)
                    .join("");
              };
              const encrypted_text = crypt("salt", this.formLabel.password);
              //setting expires cookies
              let d = new Date();
              d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 7);
              window.document.cookie =
                "password=" +
                encrypted_text +
                ";path=/;expires=" +
                d.toGMTString();
              window.document.cookie =
                "email=" +
                this.formLabel.email +
                ";path=/;expires=" +
                d.toGMTString();
              window.document.cookie =
                "remember=1;path=/;expires=" + d.toGMTString();
              window.document.cookie =
                "encryptedPass=1;path=/;expires=" + d.toGMTString();
            }
            if (
              response.data.companyId != null ||
              response.data.companyId != ""
            ) {
              window.sessionStorage.setItem(
                "companyId",
                response.data.companyId
              );
            }
            if (response.data.registerUser.faceFlag == 0) {
              for (let key in response.data.registerUser) {
                window.sessionStorage.setItem(
                  key,
                  response.data.registerUser[key]
                );
                window.sessionStorage.setItem("eo_login_flg", key);
              }
            }
            window.sessionStorage.setItem(
              "online_exam_language",
              this.$CONST.COMMON.LANGUAGE[response.data.registerUser.area]
            );
            window.localStorage.setItem("online_exam_language", this.$CONST.COMMON.LANGUAGE[response.data.registerUser.area]);
            if (response.data.registerUser.faceFlag == 1) {
              this.safeMode = 1;
              this.dialog_item = "regist";
            } else {
              window.location.reload();
            }
          } else if (response.data.codeFlag == "1002") {
            this.$el_alert_type(
              window.vm.$i18n.t("js.userNotExist"),
              "warning"
            );
          } else if (response.data.codeFlag == "1003") {
            this.$el_alert_type(
              window.vm.$i18n.t("js.passwordWrong"),
              "warning"
            );
          } else if (response.data.codeFlag == "1010") {
            this.$el_alert_type(window.vm.$i18n.t("js.passLock"), "warning");
          } else if (response.data.codeFlag == "1011") {
            this.$el_alert_type(
              window.vm.$i18n.t("js.passErrorTimer"),
              "warning"
            );
          } else if (response.data.codeFlag == "1012") {
            this.$el_alert_type(window.vm.$i18n.t("new.title109"), "warning");
          }
        });
    },

    login: function() {
      localStorage.setItem("cart",[]);
      if (!this.formLabel.email) {
        this.$el_alert_type(window.vm.$i18n.t("js.account"), "warning");
        return;
      }

      if (!this.formLabel.password) {
        this.$el_alert_type(window.vm.$i18n.t("js.passwordNull"), "warning");
        return;
      }
      this.$api
        .post("/login/login", {
          password: md5(this.formLabel.password),
          loginName: this.formLabel.email
        })
        .then(response => {
            if (response.data.codeFlag == "1001") {
              window.sessionStorage.setItem("check_login", 0);
              if (this.formLabel.remember == "1") {
                window.sessionStorage.setItem(
                  "register_password_change",
                  response.data.passwordChangeFlag
                );
                /// Mã hoá pass
                const crypt = (salt, text) => {
                  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
                  const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
                  const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);

                  return text
                      .split("")
                      .map(textToChars)
                      .map(applySaltToChar)
                      .map(byteHex)
                      .join("");
                };
                const encrypted_text = crypt("salt", this.formLabel.password);
                //setting expires cookies
                let d = new Date();
                d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 7);
                window.document.cookie =
                  "password=" +
                  encrypted_text +
                  ";path=/;expires=" +
                  d.toGMTString();
                window.document.cookie =
                  "email=" +
                  this.formLabel.email +
                  ";path=/;expires=" +
                  d.toGMTString();
                window.document.cookie =
                  "remember=1;path=/;expires=" + d.toGMTString();
                window.document.cookie =
                  "encryptedPass=1;path=/;expires=" + d.toGMTString();
              }
              this.login_show = false;
              if (
                response.data.companyId != null ||
                response.data.companyId != ""
              ) {
                window.sessionStorage.setItem(
                  "companyId",
                  response.data.companyId
                );
              }
              if (response.data.registerUser.faceFlag == 0) {
                for (let key in response.data.registerUser) {
                  window.sessionStorage.setItem(
                    key,
                    response.data.registerUser[key]
                  );
                  window.sessionStorage.setItem("eo_login_flg", key);
                }
              }
              window.sessionStorage.setItem(
                "online_exam_language",
                this.$CONST.COMMON.LANGUAGE[response.data.registerUser.area]
              );
              window.localStorage.setItem("online_exam_language", this.$CONST.COMMON.LANGUAGE[response.data.registerUser.area]);

              if (response.data.registerUser.faceFlag == 1) {
                this.safeMode = 1;
                this.dialog_item = "regist";
              } else {
                window.location.reload();
              }
            } else if (response.data.codeFlag == "1004") {
              this.userList = response.data.userList.reduce((a, v) => {
                    if (v.loginFlag == 1) {
                        a.push({
                            companyName: v.companyName,
                            token: v.token,
                            series: v.series,
                            active: false
                        });
                    }
                    return a;
              }, []);
              this.dialogVisibleCompanyList = true;
              this.login_show = false;
            } else if (response.data.codeFlag == "1002") {
              this.$el_alert_type(
                window.vm.$i18n.t("js.userNotExist"),
                "warning"
              );
            } else if (response.data.codeFlag == "1003") {
              this.$el_alert_type(
                window.vm.$i18n.t("js.passwordWrong"),
                "warning"
              );
            } else if (response.data.codeFlag == "1010") {
              this.$el_alert_type(window.vm.$i18n.t("js.passLock"), "warning");
            } else if (response.data.codeFlag == "1011") {
              this.$el_alert_type(
                window.vm.$i18n.t("js.passErrorTimer"),
                "warning"
              );
            } else if (response.data.codeFlag == "1012") {
              this.$el_alert_type(window.vm.$i18n.t("new.title109"), "warning");
            }
        })
    },

    selectCompany: function (token, series, index, indexPrev) {
      this.companyLoginInfo.token = token;
      this.companyLoginInfo.series = series;
      this.userList[index].active = true;
      if (indexPrev != null) {
        this.userList[indexPrev].active = false;
      }
      this.indexPrev = index;
    },

    // handle login
    loginCompany: function(token, series) {
      if (this.companyLoginInfo.token == null) return;

      if (!this.formLabel.email) {
        this.$el_alert_type(window.vm.$i18n.t("js.account"), "warning");
        return;
      }

      if (!this.formLabel.password) {
        this.$el_alert_type(window.vm.$i18n.t("js.passwordNull"), "warning");
        return;
      }
      this.$api
        .post("/login/loginCompany", {
          token: token,
          series: series
        })
        .then(response => {
          this.resetDataCourse();
          window.sessionStorage.removeItem("arrCourse");
          window.sessionStorage.setItem("course_login_flg", 1);
          if (response.data.codeFlag == "1001") {
            window.sessionStorage.setItem("check_login", 0);
            if (this.formLabel.remember == "1") {
              window.sessionStorage.setItem(
                "register_password_change",
                response.data.passwordChangeFlag
              );
              /// Mã hoá pass
              const crypt = (salt, text) => {
                const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
                const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
                const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);

                return text
                    .split("")
                    .map(textToChars)
                    .map(applySaltToChar)
                    .map(byteHex)
                    .join("");
              };
              const encrypted_text = crypt("salt", this.formLabel.password);
              //setting expires cookies
              let d = new Date();
              d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 7);
              window.document.cookie =
                "password=" +
                encrypted_text +
                ";path=/;expires=" +
                d.toGMTString();
              window.document.cookie =
                "email=" +
                this.formLabel.email +
                ";path=/;expires=" +
                d.toGMTString();
              window.document.cookie =
                "remember=1;path=/;expires=" + d.toGMTString();
              window.document.cookie =
                "encryptedPass=1;path=/;expires=" + d.toGMTString();
            }
            this.dialogVisibleCompanyList = false;
            if (
              response.data.companyId != null ||
              response.data.companyId != ""
            ) {
              window.sessionStorage.setItem(
                "companyId",
                response.data.companyId
              );
            }
            if (response.data.registerUser.faceFlag == 0) {
              for (let key in response.data.registerUser) {
                window.sessionStorage.setItem(
                  key,
                  response.data.registerUser[key]
                );
                window.sessionStorage.setItem("eo_login_flg", key);
              }
            }
            window.sessionStorage.setItem(
              "online_exam_language",
              this.$CONST.COMMON.LANGUAGE[response.data.registerUser.area]
            );
            window.localStorage.setItem("online_exam_language", this.$CONST.COMMON.LANGUAGE[response.data.registerUser.area]);
            if (response.data.registerUser.faceFlag == 1) {
              this.safeMode = 1;
              this.dialog_item = "regist";
            } else {
              window.location.reload();
            }
          } else if (response.data.codeFlag == "1002") {
            this.$el_alert_type(
              window.vm.$i18n.t("js.userNotExist"),
              "warning"
            );
          } else if (response.data.codeFlag == "1003") {
            this.$el_alert_type(
              window.vm.$i18n.t("js.passwordWrong"),
              "warning"
            );
          } else if (response.data.codeFlag == "1010") {
            this.$el_alert_type(window.vm.$i18n.t("js.passLock"), "warning");
          } else if (response.data.codeFlag == "1011") {
            this.$el_alert_type(
              window.vm.$i18n.t("js.passErrorTimer"),
              "warning"
            );
          } else if (response.data.codeFlag == "1012") {
            this.$el_alert_type(window.vm.$i18n.t("new.title109"), "warning");
          }
        });
    },

    app_Android: function() {
      this.app_Android_flag = true;
    },

    // go to page search
    gotosearch() {
      this.$router.push({
        path: "/home/search",
        query: {
          keyword: this.keyword
        }
      });
    },

    // handle Identify Start
    crooper: function() {
      this.openCamera();
      var video = document.getElementById("video");
      var canvas1 = document.getElementById("canvasCamera");
      var context1 = canvas1.getContext("2d");
      context1.drawImage(video, 0, 0, 290, 200);
      var base64 = canvas1.toDataURL("images/png");
      var arr = base64.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = window.atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      let crooperImg = new File([u8arr], "filename", { type: mime });
      let faceInName = this.formLabel.email;

      let formData = new FormData();
      formData.append("faceImage", crooperImg);
      formData.append("faceInName", faceInName);
      //登录
      this.$api.form("/login/facelogin", formData).then(response => {
        if (response.data.codeFlag == "1001") {
          for (let key in response.data.registerUser) {
            window.sessionStorage.setItem(key, response.data.registerUser[key]);
            window.sessionStorage.setItem("eo_login_flg", key);
          }
          window.location.reload();
        } else if (response.data.codeFlag == "1002") {
          this.$el_alert_type(window.vm.$i18n.t("js.userNotExist"), "warning");
        } else if (response.data.codeFlag == "1003") {
          this.$el_alert_type(window.vm.$i18n.t("js.passwordWrong"), "warning");
        } else if (response.data.codeFlag == "1004") {
          this.$el_alert_type(window.vm.$i18n.t("js.failMatch"), "warning");
        } else if (response.data.codeFlag == "1005") {
          this.$el_alert_type(window.vm.$i18n.t("js.faceFail"), "warning");
        }
      });
    },

    checkAgreement: function() {
      this.agreement_show = false;
      this.formLabel.agree = true;
    },

    //跳转至新页面
    shareTo: function(url) {
      window.open(url);
    },

    // clear label of form
    clearFormLabel: function() {
      for (let key in this.formLabel) {
        this.formLabel["remember"] = "";
      }
    },

    // dialog confirm logout
    quite: function() {
      this.$confirm(
        window.vm.$i18n.t("js.quite"),
        window.vm.$i18n.t("js.hint"),
        {
          confirmButtonText: window.vm.$i18n.t("js.confirm"),
          cancelButtonText: window.vm.$i18n.t("js.cancel"),
          cancelButtonClass: "btn-custom-cancel",
          type: "warning"
        }
      )
        .then(() => {
          // reset data khóa học của tôi
          this.resetDataCourse();

          //window.sessionStorage.setItem("online_exam_language", "");
          this.userId = window.sessionStorage.getItem("id");
          //删除cookies
          let _date = new Date();
          _date.setDate(_date.getDate() - 1);
          _date.toGMTString();

          // document.cookie = "remember='';expires=" + _date.toGMTString();
          var oel = window.sessionStorage.getItem("online_exam_language");
          //删除sessionStorage
          window.sessionStorage.clear();
          localStorage.clear();
          //通知其他页面删除session
          localStorage.setItem("deleteSessionStorage", Date.now().toString());
          window.sessionStorage.setItem("eo_login_flg", 0);
          window.sessionStorage.setItem("course_login_flg", 0);
          this.$api.post("/login/logout");
          document.cookie = "token-dongdu='';expires=" + _date.toGMTString();
          this.$i18n.locale = oel;
          this.languageType = false;
          window.sessionStorage.setItem("online_exam_language", oel);
          window.localStorage.setItem("online_exam_language", oel);
          //返回首页
          this.$router.push("/");
          //刷新页面
          window.location.reload();
        })
        .catch(() => {});
    },

    enterprise_login: function() {
      this.login_enterprise = true;
    },

    enterprise_login_opt: function() {
      alert("登录在线教育");
    },

    //登录信息设置
    login_info_set: function(id, name, headImagePath) {
      this.userId = id;
      this.formLabel.userName = name;
      this.userImg = headImagePath;
      localStorage.removeItem("loginInfo");
    },

    //修改头像值回传
    edit_head_image: function(headImageUrl) {
      this.userImg = headImageUrl;
    },

    openCamera() {
      let video = this.$refs.video; //获取要放视频的video标签节点
      let _this = this;
      if (navigator.mediaDevices.getUserMedia === undefined) {
        //判断当前设备是否有摄像设备
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia;
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      var constraints = { audio: false, video: true };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function(stream) {
          _this.stream = stream;
          _this.mediaStreamTrack =
            typeof stream.stop === "function" ? stream : stream.getTracks()[0];
          // 旧的浏览器可能没有srcObject
          if ("srcObject" in video) {
            video.srcObject = stream;
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            video.src = window.URL.createObjectURL(stream);
          }
          video.onloadedmetadata = function(e) {
            video.play(); //打开摄像头
          };
        })
        .catch(err => {});
    },

    // show menu language
    languageShow: function() {
      const that = this;
      that.languageType = true;
    },

    // hidden menu language
    languageHidden: function() {
      const that = this;
      that.languageType = false;
    },

    // change language
    changeLanguage: function(language) {
      this.$i18n.locale = language;
      this.languageType = false;
      window.sessionStorage.setItem("online_exam_language", language);
      window.localStorage.setItem("online_exam_language", language);
      window.localStorage.removeItem("cart");
      //跳转到home页面
      this.$router.push("/");
      //强制刷新
      window.location.reload();
    },

    // redirect footer tag page
    redirectFooter: function(str) {
      const self = this;
      switch (str) {
        case "app_Android":
          self.app_Android();
          break;
        case "operation":
          self.operation();
          break;
        case "faq":
          self.faq();
          break;
        case "protocol":
          self.protocol();
          break;
        case "policy":
          self.policy();
          break;
      }
    },

    // check is mobile
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    // check is IOS
    _isIphone() {
      let flag = navigator.userAgent.match(
        /(iPhone|iPod|ios|iPad)/i
      );
      return flag;
    },

    activeRow: function (activeID) {
      if (this.activeID == activeID && this.activeID != null) {
        this.activeID =  null;
      } else {
        this.activeID = activeID;
      }
    },

    // go to live course page
    pageLiveCourse: function() {
      this.$router.push("/home/live/course");
    }
  },

  mounted() {
    this.checkDataGeneralEnvironment = this.checkGeneralEnvironment();
    if (this._isMobile()) {
      this.isCheckedStatus = true;
    } else {
      this.isCheckedStatus = false;
    }
    if (this._isIphone()) {
      this.isCheckIphone = true;
    } else {
      this.isCheckIphone = false;
    }
    let logout_title = "";
    let logout_content = "";
    let logout_button = "";
    let loginFlagContent = ""
    let isDeleteContent = ""
    if (this.$lang() == "1") {
      picker.use(zh);
      $("body").addClass("cn");
      logout_content = "您的帐户已在另一台设备上登录。";
      loginFlagContent = "此帐号已被禁用！";
      isDeleteContent = "用户不存在"
      logout_title = "警告";
      logout_button = "同意";
    } else if (this.$lang() == "2") {
      picker.use(en);
      logout_content = "Your account has been logged in on another device.";
      loginFlagContent = "This account has been disabled!";
      isDeleteContent = "The user does not exist!"
      logout_title = "Warning";
      logout_button = "OK";
    } else if (this.$lang() == "3") {
      $("body").addClass("jp");
      picker.use(ja);
      logout_content = "アカウントが別のデバイスにログインしています。";
      loginFlagContent = "このアカウントは無効になっています！";
      isDeleteContent = "該当のユーザは存在しません。"
      logout_title = "警告";
      logout_button = "同意";
    } else if (this.$lang() == "4") {
      picker.use(vi);
      logout_content = "Tài khoản của bạn đã được đăng nhập trên một thiết bị khác.";
      loginFlagContent = "Tài khoản này đã bị vô hiệu!";
      isDeleteContent = "Người dùng không tồn tại."
      logout_title = "Cảnh báo";
      logout_button = "Đồng ý";
    } else {
      if (window.sessionStorage.getItem("online_exam_language") == "") {
        picker.use(ja);
      } else {
        picker.use(window.sessionStorage.etItem("online_exam_language"));
      }
    }
    /// 401 logout
    let isLogoutUser = window.sessionStorage.getItem("isLogOutUser");
    if(isLogoutUser=="true"){
      // this.logout_show = true;
      this.$alert(logout_content, logout_title, {
        confirmButtonText: logout_button,
        type:"warning",
        dangerouslyUseHTMLString:true
      });
      window.sessionStorage.setItem("isLogOutUser", false);
    }

    /// check account is disabled
    let isLogoutUserLoginFlag = window.sessionStorage.getItem("isLogoutUserLoginFlag");
    if(isLogoutUserLoginFlag=="true"){
      this.$alert(loginFlagContent, logout_title, {
        confirmButtonText: logout_button,
        type:"warning",
        dangerouslyUseHTMLString:true
      });
      window.sessionStorage.setItem("isLogoutUserLoginFlag", false);
    }

    // check account is delete
    let isDeleteUser = window.sessionStorage.getItem("isDeleteUser");
    if(isDeleteUser=="true"){
      this.$alert(isDeleteContent, logout_title, {
        confirmButtonText: logout_button,
        type:"warning",
        dangerouslyUseHTMLString:true
      });
      window.sessionStorage.setItem("isDeleteUser", false);
    }
    // 新开页面不存在sessionStorage,从其他已开页面获取
    if (!sessionStorage.length) {
      localStorage.setItem("getSessionStorage", Date.now().toString());
    }

    //给window添加一个滚动滚动监听事件
    document
      .getElementById("app")
      .addEventListener("scroll", this.handleScroll);
    window.addEventListener("storage", e => {
      if (localStorage.getItem("loginInfo")) {
        let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
        if (loginInfo.codeFlag == "1001") {
          window.sessionStorage.setItem(
            "isFirstThirdLogin",
            loginInfo.isFirstThirdLogin
          );
          for (let key in loginInfo.registerUser) {
            window.sessionStorage.setItem(key, loginInfo.registerUser[key]);
            window.sessionStorage.setItem("eo_login_flg", key);
          }
          let id = loginInfo.registerUser.id;
          let name = loginInfo.registerUser.name;
          let headImagePath = loginInfo.registerUser.headImagePath;
          if (headImagePath == "" || !headImagePath) {
            headImagePath = "static/images/profile.jpg";
          }
          this.login_info_set(id, name, headImagePath);
        } else {
          this.$el_alert_type(loginInfo.message, "warning");
          localStorage.removeItem("loginInfo");
        }
      }
      this.login_show = false;
      //为新开页面赋值sessionStorage
      if (e.key == "getSessionStorage") {
        // 已存在的标签页会收到这个事件
        localStorage.setItem("sessionStorage", JSON.stringify(sessionStorage));
        localStorage.removeItem("sessionStorage");
      } else if (e.key == "deleteSessionStorage") {
        var oel = window.sessionStorage.getItem("online_exam_language");
        //删除sessionStorage
        window.sessionStorage.clear();
        localStorage.clear();
        this.userId = "";
        this.$i18n.locale = oel;
        this.languageType = false;
        window.sessionStorage.setItem("online_exam_language", oel);
      } else if (e.key == "sessionStorage" && !sessionStorage.length) {
        // 新开启的标签页会收到这个事件
        let data = JSON.parse(e.newValue);
        for (let k in data) {
          sessionStorage.setItem(k, data[k]);
        }
        //赋值后重新执行登录方法
        this.$autoLogin().then(
          () => {
            this.userId = window.sessionStorage.getItem("id");
            this.formLabel.userName = window.sessionStorage.getItem("name");
            if (
              window.sessionStorage.getItem("headImagePath") == null ||
              window.sessionStorage.getItem("headImagePath") == ""
            ) {
              this.userImg = "static/images/profile.jpg";
            } else {
              this.userImg = window.sessionStorage.getItem("headImagePath");
            }
          },
          () => {}
        );
      }
    });
    this.$autoLogin().then(
      () => {
        window.sessionStorage.setItem("course_login_flg", 1);
        if (window.sessionStorage.getItem("passwordChangeFlag")==0
            &&window.sessionStorage.getItem("confirmPasswordChangeFlagFirst")==null
            &&this.isCheckIphone
        ){
            this.$alert(window.vm.$i18n.t("new.title17"), "", {
              confirmButtonText: window.vm.$i18n.t("js.confirm"),
              type:"warning",
              dangerouslyUseHTMLString:true
            });
            window.sessionStorage.setItem("confirmPasswordChangeFlagFirst", "true");
        } else if(window.sessionStorage.getItem("passwordChangeFlag")==0
                &&window.sessionStorage.getItem("confirmPasswordChangeFlagFirst")==null
                &&!this.isCheckIphone
        ){
            this.$router.push({
              path: "/home/personSet",
            });
        }
        this.userId = window.sessionStorage.getItem("id");
        this.companyId = window.sessionStorage.getItem("companyId");
        //获取未读直播消息个数
        this.$api
          .post("/home/getNumberOfUnreadMessages", {
            languageType: this.$lang()
          })
          .then(response => {
            this.message_number = response.data;
          })
          .then(() => {
            //获取未读消息中心个数
            //this.$api
            //  .post("/personalCenter/getNumberOfUnreadMessages", {
            //  })
            //  .then(response => {
            //    this.message_number_person = response.data;
            //    eventBus.$emit("addition", {
            //      messageNumber: this.message_number_person
            //    });
            //  });
          });

        this.formLabel.userName = window.sessionStorage.getItem("name");
        if (
          window.sessionStorage.getItem("headImagePath") == null ||
          window.sessionStorage.getItem("headImagePath") == ""
        ) {
          this.userImg = "static/images/profile.jpg";
        } else {
          this.userImg = window.sessionStorage.getItem("headImagePath");
        }
      },
      () => {
        window.sessionStorage.setItem("course_login_flg", 0);
        let token = window.document.cookie.match('(^|;) ?token-dongdu=([^;]*)(;|$)');
        token = token ? token[2] : null;
        let courseLoginFlg = window.sessionStorage.getItem("course_login_flg");
        if (token&&courseLoginFlg=="0") {
            let _date = new Date();
            _date.setDate(_date.getDate() - 1);
            _date.toGMTString();
            document.cookie = "token-dongdu='';expires=" + _date.toGMTString();
            document.cookie = "remember='';expires=" + _date.toGMTString();
            window.location.reload();
        }
      }
    );
    eventBus.$on("addition", param => {
      this.messageNumber = param.messageNumber;
    });
  },

  destroyed() {
    //离开该页面需要移除这个监听的事件
    // window.removeEventListener('scroll', this.handleScroll)
    document
      .getElementById("app")
      .removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .default_btn_login {
    border-radius: 20px;
    background-color: #9c9d9f !important;
    color: #fff !important;
    font-size: 14px!important;
    font-weight: bold!important;
    padding: 8px 12px !important;
  }
  .primary_btn_login {
    border-radius: 20px;
    background-color: #0071c5 !important;
    font-size: 14px!important;
    font-weight: bold!important;
    padding: 8px 12px !important;
  }

  .company_list {
      display: flex;
      flex-direction: row;
      height: 100%;
      justify-content: space-evenly;
      align-items: center;
  }
  .company_list .div_c {
      height: 90%;
      width: calc(40% - 10px);
      background-color: #ffffff;
      border-radius: 10px;
      transition: ease 0.5s;
      margin: 5px;
      cursor: pointer;
  }
  .company_list .div_c:hover {
      box-shadow: 0 10px 20px rgb(0 0 0 / 19%), 0 6px 6px rgb(0 0 0 / 23%);
  }
  .company_list .div_c .d-img {
      height: 80%;
  }
  .company_list .div_c .d-img img {
      margin: auto;
      height: 100%;
  }
  .company_list .div_c .d-span {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 20%;
  }
  .conpany_login.pc .company_list .div_c .d-span span {
      font-size: 18px;
      color: #0071c5;
      font-weight: 400;
  }

  .conpany_login.mobile .company_list .div_c {
      width: calc(50% - 10px);
      height: auto;
  }
  .conpany_login.mobile .company_list {
      flex-wrap: wrap;
  }
  .conpany_login.mobile .company_list .div_c .d-span span {
      font-size: 14px;
      color: #0071c5;
      font-weight: 600;
      padding: 0 2px;
      word-break: break-all;
  }

  .blog-pop .blog-pop-box {
		box-sizing: border-box;
		text-align: center;
	}
	.blog-pop .blog-pop-box .close-pop {
    color: #8C8889;
    font-size: 16px;
    position: absolute;
    top: 11px;
    right: 10px;
    cursor: pointer;
    transition: all 0.2s;
    -moz-transition: all 0.2s;
    -o-transition: all 0.2s;
    -webkit-transition: all 0.2s;
}
.icon_menu_close:before {
    content: "\e692";
}
.blog-pop .blog-pop-box h4 {
    font-size: 24px;
    font-weight: 600;
    color: #2e2f30;
    line-height: 29px;
    margin-bottom: 6px;
    word-break: break-word;
}
.blog-pop .blog-pop-box .title-p {
    color: #8C8889;
}

.blog-pop .blog-pop-box p {
    font-size: 16px;
    color: #2e2f30;
    line-height: 19px;
    margin-top: 6px;
}
.blog-pop .blog-pop-box .fea {
    display: inline-block;
    width: calc((100% + 60px) / 3);
    max-width: 190px;
    vertical-align: top;
}
.blog-pop .blog-pop-box .fea.active {
    border: 1px solid #0071c5;
    border-radius: 8px;
    box-shadow: 0px 1px 10px 1px #0071c573;
}
.blog-pop .blog-pop-box .fea img {
    width: 100%;
    max-width: 100px;
    vertical-align: top;
    margin: auto;
}
.blog-pop .blog-pop-box p {
    font-size: 16px;
    color: #2e2f30;
    height: 40px;
    word-break: break-word;
}
.blog-pop .blog-pop-box a {
    margin: 20px auto 0;
    padding: 0;
    width: 220px;
    height: 48px;
    line-height: 48px;
    font-size: 18px;
}
.banner-btn {
    padding: 0 34px;
    margin: 72px auto 25px;
    line-height: 56px;
    border-radius: 6px;
    height: 56px;
    font-size: 16px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #7bed9f;
    display: inline-block;
    color: #ffffff;
    -webkit-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
    text-align: center;
	text-decoration: none;
	cursor: pointer;
}
.banner-btn:hover {
    background-color: #2ed573;
}
.blog-content {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin: 20px auto 0;
    align-items: flex-start;
}
.banner-btn.disabled {
    background-color: #9da19e;
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue